import { groupReportNavigation } from './navigation/groupReportNavigation';
import ReportServiceIcon from './report-components/shared/ReportServiceIcon';
import { getServiceLogo, getMenuService } from './report-components/shared/serviceIcons';
import ChatGPTAdsReport from './views/chatgpt-ads';
import AppUsageReport from './views/app-usage';
import { getReportTableSx } from './views/shared/report-table-styles';
// AppWithVars.js
import { useState, useEffect, useContext, useMemo, useRef, useCallback, useLayoutEffect } from 'react';
import { BrowserRouter, Navigate, useRoutes, useLocation, useNavigate } from 'react-router-dom';
import { AppProvider, DashboardLayout } from '@toolpad/core';
import { TokenProvider } from './Login/TokenProvider';
import { ReportProfileProvider, useReportProfile } from './context/ReportProfileContext';
import { AppVarsContext } from './context/AppVarsContext';
import { ThemeProvider } from '@mui/material/styles';
import { alpha, Box, CircularProgress, Typography } from '@mui/material';
import { createReportBrandTheme } from './system/report-brand-theme';
import OverView from './views/overview';
import HubSpotReport from './views/hubspot';
import SetSessionInfo from './system/set-session-info';
import SidebarFooterAccount, { ToolbarAccountOverride } from './system/account-menu';
import ErrorBoundary from './views/error-boundry';
import MonthlyToolbar from './views/monthly-toolbar';
import { MdSpaceDashboard, MdOutlineError, MdSpeakerNotes, MdCampaign, MdAnalytics } from "react-icons/md";
import { TbBrandBing } from "react-icons/tb";
import { FaRegImage, FaDisplay, FaMailchimp, FaHandHoldingDollar } from "react-icons/fa6";
import { AiTwotoneMail } from "react-icons/ai";
import { BsHouseDoor } from 'react-icons/bs';
import { FaGoogle } from "react-icons/fa6";
import { SiLinkedin, SiMeta } from 'react-icons/si';
import moment from 'moment';
import ContactRep from './system/ContactRep';
import GoogleCampaignGrid from './views/google/google-campaigns';
import Bing from './views/bing';
import Nextdoor from './views/nextdoor';
import LinkedIN from './views/linkedin';
import StackAdapt from './views/stackadapt';
import MailChimpCampaigns from './views/mailchimp/mailchimp-campaigns';
import LuminateReport from './views/luminate';
import SalsaLabsReport from './views/salsa-labs/salsa-labs-campaigns';
import Comments from './views/comments'
import Meta from './views/meta';
import { UserProvider, useUserProfile } from './context/UserProvider';

import LightBoxes from './views/LightBoxes';
import ConstantContact from './views/constant-contact/constant-contact-campaigns';
import DeliveraReport from './views/delivera';
import MauticReport from './views/mautic';
import VirtuousReport from './views/virtuous/report';
import PrivacyPolicyPage from './system/privacy-policy';
import TermsOfServicePage from './system/terms-of-service';
import GoLinkSetter from './routes/GoLinkSetter';
import GA4SummaryView from './views/ga4-analytics';
import RestaurantAnalytics from './views/restaurant-analytics';
import InstantAnalysis from './views/instant-analysis';
import DonationPlatformReport from './views/donation-platform';
import ViMarcMeta from './views/retail/meta';
import ViMarcOverview from './views/retail/awareness';
import ViMarcGoogleCampaignGrid from './views/retail/google';
import ViMarcStackAdapt from './views/retail/stackadapt';
import DisplayRetail from './views/display-retail';
import MatomoReport from './views/matomo';
import InfillionReport from './views/infillion';
import InfillionVisualHarness from './views/infillion/visual-harness';
import { buildCatalogRoutes } from './routes/reportCatalogRoutes';
import { hydrateReportId, persistReportId } from './system/report-id-storage';
import { hydratePersistedSession, installSessionCookieBridge } from './system/session-persistence';


const RootRedirect = () => {
  useEffect(() => {
    window.location.replace('https://app.reportwerks.com');
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <CircularProgress />
    </Box>
  );
};

const AppWithVars = ({ appID }) => {
  installSessionCookieBridge();
  hydratePersistedSession();
  hydrateReportId();
  const [menu, setMenu] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const sidebarRouter = useMemo(() => ({
    pathname: location.pathname,
    searchParams: new URLSearchParams(location.search),
    navigate: (url, options) => navigate(String(url), { replace: options?.history === 'replace' }),
  }), [location.pathname, location.search, navigate]);
  const currentReportPath = useRef(location.pathname);
  currentReportPath.current = location.pathname;
  const [loading, setShellLoading] = useState(false);
  const setLoading = useCallback((next) => {
    if (currentReportPath.current === location.pathname) setShellLoading(Boolean(next));
  }, [location.pathname]);
  useLayoutEffect(() => { setShellLoading(false); }, [location.pathname]);
  const [homeUrl, setHomeUrl] = useState(() => localStorage.getItem('_home') || '/mr');
  const [client, setClient] = useState((sessionStorage.getItem('client') !== null && sessionStorage.getItem('client') !== "null" ? JSON.parse(sessionStorage.getItem('client')) : {}));
  const reportRef = useRef(null);
  const { appVars, appLoading } = useContext(AppVarsContext);
  const { reportProfile, loading: profileLoading, appMenu } = useReportProfile();

  const { user, loading: userLoading } = useUserProfile();





  //console.log('Report Profile Context', reportProfile);
  //console.log('User', user);
  //console.log("ID", id);

  const defaultStart = moment().subtract(7, 'days').format("YYYY-MM-DD");
  const defaultEnd = moment().format("YYYY-MM-DD");

  //console.log('sDate', sessionStorage.getItem('sDate'));



  const [selectedDateS, setSelectedDateS] = useState(() => {
    return sessionStorage.getItem('sDate') || defaultStart;
  });

  const [selectedDateE, setSelectedDateE] = useState(() => {
    return sessionStorage.getItem('eDate') || defaultEnd;
  });
  const handleRangeSelect = (rangeKey) => {
    setSelectedDateS(rangeKey?.sDate || moment(rangeKey.startDate).format('YYYY-MM-DD'));
    setSelectedDateE(rangeKey?.eDate || moment(rangeKey.endDate).format('YYYY-MM-DD'));
  };


  if (!sessionStorage.getItem('sDate')) sessionStorage.setItem('sDate', defaultStart);
  if (!sessionStorage.getItem('eDate')) sessionStorage.setItem('eDate', defaultEnd);

  const theme = useMemo(() => createReportBrandTheme(reportProfile?.color), [reportProfile?.color]);

  function injectIconsIntoMenu(menuItems, iconMap, parentSegment = "") {
  //  console.log('Injecting icons into menu:', menuItems);
    return Object.entries(menuItems).map(([key, item]) => {
      const segment = item.segment;
      return {
        ...item,
        title: item.title,
        icon: getServiceLogo(getMenuService(item)) ? <ReportServiceIcon service={getMenuService(item)} size={25} /> : iconMap[item.icon] || item.icon,
        to: `/${segment}`,
        children: item.children ? injectIconsIntoMenu(item.children, iconMap, segment) : undefined,
      };
    });
  }

  const icons = {
    dashboard: <MdSpaceDashboard size={25} color={theme.palette.primary.main} />,
    lightbox: <FaRegImage size={25} color={theme.palette.primary.main} />,
    errors: <MdOutlineError size={25} color={theme.palette.primary.main} />,
    notes: <MdSpeakerNotes size={25} color={theme.palette.primary.main} />,
    campaigns: <MdCampaign size={25} color={theme.palette.primary.main} />,
    google: <FaGoogle size={25} color={theme.palette.primary.main} />,
    meta: <SiMeta size={25} color={theme.palette.primary.main} />,
    nextdoor: <BsHouseDoor size={25} color={theme.palette.primary.main} />,
    bing: <TbBrandBing size={25} color={theme.palette.primary.main} />,
    display: <FaDisplay size={25} color={theme.palette.primary.main} />,
    email: <AiTwotoneMail size={25} color={theme.palette.primary.main} />,
    luminate: <AiTwotoneMail size={25} color={theme.palette.primary.main} />,
    mailchimp: <FaMailchimp size={25} color={theme.palette.primary.main} />,
    mautic: <AiTwotoneMail size={25} color={theme.palette.primary.main} />,
    delivera: <AiTwotoneMail size={25} color={theme.palette.primary.main} />,
    constantcontact: <FaMailchimp size={25} color={theme.palette.primary.main} />,
    salsalabs: <AiTwotoneMail size={25} color={theme.palette.primary.main} />,
    virtuous: <MdAnalytics size={25} color={theme.palette.primary.main} />,
    donations: <FaHandHoldingDollar size={25} color={theme.palette.primary.main} />,
    linkedin: <SiLinkedin size={25} color={theme.palette.primary.main} />,
    matomo: <MdAnalytics size={25} color={theme.palette.primary.main} />,
    analytics: <MdAnalytics size={25} color={theme.palette.primary.main} />,
    chatgpt_ads: <MdCampaign size={25} color={theme.palette.primary.main} />,
    infillion: <MdCampaign size={25} color={theme.palette.primary.main} />,
    reportwerks: <Box component="img" src="/apple-touch-icon.png" alt="ReportWerks" sx={{ width: 24, height: 24, borderRadius: '6px' }} />,
    openai: <Box component="img" src="/apple-touch-icon.png" alt="ReportWerks" sx={{ width: 24, height: 24, borderRadius: '6px' }} />
  };



  const routes = useMemo(() => buildCatalogRoutes([
    { path: '*', element: <ErrorBoundary />, errorElement: <ErrorBoundary /> },
    { path: '/', element: <RootRedirect /> },
    { path: '/scv/reports', element: <Navigate to="/mr" replace /> },
    { path: '/session/:id', element: <SetSessionInfo setClient={setClient} /> },
    {
      path: '/mr/',
      report: true,
      element: <OverView setLoading={setLoading} reportProfile={reportProfile} />
    },
    {
      path: '/overview/',
      report: true,
      element: <OverView setLoading={setLoading} reportProfile={reportProfile} />
    },
    {
      path: '/mr/google/paid',
      report: true,
      element: <GoogleCampaignGrid setLoading={setLoading} reportProfile={reportProfile} title="Google Paid" type="paid" />
    },
    {
      path: '/mr/google/grant',
      report: true,
      element: <GoogleCampaignGrid setLoading={setLoading} reportProfile={reportProfile} title="Google Grant" type="grant" />
    },
    {
      path: '/mr/google/analytics/restaurant',
      report: true,
      element: <RestaurantAnalytics setLoading={setLoading} />
    },
    {
      path: '/mr/google/analytics',
      report: true,
      element: <GA4SummaryView setLoading={setLoading} reportProfile={reportProfile} />
    },
    {
      path: '/mr/instant-analysis',
      report: true,
      element: <InstantAnalysis setLoading={setLoading} reportProfile={reportProfile} title="ReportWerks Instant Analysis" />
    },
    {
      path: '/instant-analysis',
      report: true,
      element: <InstantAnalysis setLoading={setLoading} reportProfile={reportProfile} title="ReportWerks Instant Analysis" />
    },
    {
      path: '/reportwerks-instant-analysis',
      report: true,
      element: <InstantAnalysis setLoading={setLoading} reportProfile={reportProfile} title="ReportWerks Instant Analysis" />
    },
    {
      path: '/mr/nextdoor',
      report: true,
      element: <Nextdoor setLoading={setLoading} reportProfile={reportProfile} title="Nextdoor" type="nextdoor" />
    },
    {
      path: '/mr/bing',
      report: true,
      element: <Bing setLoading={setLoading} reportProfile={reportProfile} title="Bing" type="bing" />
    },
    {
      path: '/mr/linkedin',
      report: true,
      element: <LinkedIN setLoading={setLoading} reportProfile={reportProfile} title="LinkedIN" type="linkedin" />
    },
    {
      path: '/mr/display',
      report: true,
      element: <StackAdapt setLoading={setLoading} reportProfile={reportProfile} title="Programmatic" type="stackadapt" />
    },
    {
      path: '/mr/app-usage',
      report: true,
      element: <AppUsageReport reportProfile={reportProfile} />,
    },
    {
      path: '/mr/chatgpt-ads',
      report: true,
      element: <ChatGPTAdsReport setLoading={setLoading} reportProfile={reportProfile} />,
    },
    {
      path: '/mr/infillion',
      report: true,
      element: <Navigate to="/mr/programmatic" replace />
    },
    {
      path: '/mr/matomo',
      report: true,
      element: <MatomoReport setLoading={setLoading} reportProfile={reportProfile} />
    },
    {
      path: '/mr/programmatic',
      report: true,
      element: <InfillionReport setLoading={setLoading} reportProfile={reportProfile} title="Programmatic" />
    },
    {
      path: '/mr/meta',
      report: true,
      element: <Meta setLoading={setLoading} reportProfile={reportProfile} title="Meta" type="meta" />
    },
    {
      path: '/mr/lightboxes',
      report: true,
      element: <LightBoxes setLoading={setLoading} reportProfile={reportProfile} title="Lightboxes" type="lightbox" />
    },
    { path: '/mr/hubspot', report: true, element: <HubSpotReport setLoading={setLoading} title="HubSpot" /> },
    { path: '/mr/luminate',
      report: true, element: <LuminateReport setLoading={setLoading} /> },
    {
      path: '/mr/mailchimp',
      report: true,
      element: <MailChimpCampaigns setLoading={setLoading} reportProfile={reportProfile} title="MailChimp" type="mailchimp" />
    },
    {
      path: '/mr/delivera',
      report: true,
      element: <DeliveraReport setLoading={setLoading} reportProfile={reportProfile} title="Delivra" type="delivera" />
    },
    {
      path: '/mr/mautic',
      report: true,
      element: <MauticReport setLoading={setLoading} reportProfile={reportProfile} cid={sessionStorage.getItem('rid')} />
    },
    {
      path: '/mr/constant-contact',
      report: true,
      element: <ConstantContact setLoading={setLoading} reportProfile={reportProfile} title="Constant Contact" type="constant-contact" />
    },
    {
      path: '/mr/salsa-labs',
      report: true,
      element: <SalsaLabsReport setLoading={setLoading} reportProfile={reportProfile} title="Salsa Labs" type="salsa-labs" />
    },
    {
      path: '/mr/virtuous',
      report: true,
      element: <VirtuousReport setLoading={setLoading} reportProfile={reportProfile} title="Virtuous" type="virtuous" />
    },
    {
      path: '/mr/donations',
      report: true,
      element: <DonationPlatformReport setLoading={setLoading} reportProfile={reportProfile} title="Donation Platform" />
    },
    {
      path: '/privacy',
      element: <PrivacyPolicyPage />
    },
    {
      path: '/terms-of-service',
      element: <TermsOfServicePage />
    },
    {
      path: '/awareness',
      report: true,
      element: <ViMarcOverview setLoading={setLoading} reportProfile={reportProfile} />
    },
    {
      path: '/meta/retail',
      report: true,
      element: <ViMarcMeta setLoading={setLoading} reportProfile={reportProfile} title="Meta" type="meta" />
    },
    {
      path: '/display/retail',
      report: true,
      element: <DisplayRetail setLoading={setLoading} reportProfile={reportProfile} title="Programmatic Retail" type="stackadapt" />
    },
    {
      path: '/vimarc/mr/display',
      report: true,
      element: <ViMarcStackAdapt setLoading={setLoading} reportProfile={reportProfile} title="Programmatic" type="stackadapt" />
    },
    {
      path: '/google/retail',
      report: true,
      element: <ViMarcGoogleCampaignGrid setLoading={setLoading} reportProfile={reportProfile} title="Google Paid" type="paid" />
    },
    {
      path: '/vimarc/mr/google/grant',
      report: true,
      element: <ViMarcGoogleCampaignGrid setLoading={setLoading} reportProfile={reportProfile} title="Google Grant" type="grant" />
    },
    {
      path: 'mr/notes',
      report: true,
      element: <Comments standalone
        eDate={sessionStorage.getItem('eDate')}
        sDate={sessionStorage.getItem('sDate')}
        color={theme.palette.primary.main}
        admintoken={0}
        view={"a7edd5c0-7a77-49ed-86ad-6fe3066a0f59"}
        type={"All"}
        setLoading={setLoading}
      />
    }
  ], reportProfile), [reportProfile, client, theme.palette.primary.main, setLoading]);


  //console.log('sDate', selectedDateS);
  //console.log("eDate", selectedDateE);

  const element = useRoutes(routes);
  const id = location.pathname.split("/")[1];
  useEffect(() => {
    const update = () => {
      setSelectedDateS(sessionStorage.getItem('sDate') || defaultStart);
      setSelectedDateE(sessionStorage.getItem('eDate') || defaultEnd);
    };
    window.addEventListener('dc', update);
    return () => window.removeEventListener('dc', update);
  }, [defaultStart, defaultEnd]);

  //  console.log('Active route:', `${id}`);

  const activeTitle = useMemo(() => {
    if (!menu || !Array.isArray(menu)) {
      return reportProfile?.title || reportProfile?.name || client?.name || 'Report';
    }
    const findTitle = (items) => {
      for (const item of items) {
        if (item?.to === location.pathname) {
          return item.title;
        }
        if (Array.isArray(item?.children)) {
          const childTitle = findTitle(item.children);
          if (childTitle) return childTitle;
        }
      }
      return null;
    };
    return findTitle(menu) || reportProfile?.title || reportProfile?.name || client?.name || 'Report';
  }, [menu, location.pathname, reportProfile, client]);

  const shellSx = useMemo(() => ({
    position: 'relative',
    minHeight: '100vh',
    background: 'transparent',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      pointerEvents: 'none',
      background: `
        radial-gradient(circle at top left, ${alpha(theme.palette.primary.light || theme.palette.primary.main, 0.18)} 0%, transparent 24%),
        radial-gradient(circle at top right, ${alpha(theme.palette.secondary.main, 0.14)} 0%, transparent 28%),
        linear-gradient(180deg, ${alpha('#ffffff', 0.98)} 0%, ${alpha('#f5fbff', 0.96)} 44%, ${alpha('#ffffff', 0.98)} 100%)
      `
    },
    '& .MuiAppBar-root': {
      bgcolor: 'transparent',
      background: `linear-gradient(180deg, ${alpha('#ffffff', 0.88)} 0%, ${alpha('#ffffff', 0.68)} 100%)`,
      backdropFilter: 'blur(18px)',
      borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
      boxShadow: `0 12px 24px ${alpha(theme.palette.primary.main, 0.06)}`,
      color: theme.palette.text.primary,
    },
    '& .MuiToolbar-root': {
      minHeight: { xs: 72, md: 78 },
      px: { xs: 1.5, md: 2.25 },
      gap: 1.25,
    },
    '& main': {
      padding: { xs: 1, sm: 0 },
      position: 'relative',
      background: 'transparent',
    }
  }), [theme]);


  if (id === 'session') {
    persistReportId(location.pathname.split("/")[2]);
  }








  useEffect(() => {
    if (reportProfile?.tabs) {
      try {
        const parsed = appMenu;
      //  console.log('tabs', parsed);
        const withIcons = injectIconsIntoMenu(parsed, icons);
        setMenu(groupReportNavigation(withIcons));
       // console.log('Menu:', withIcons);
      } catch (err) {
        console.error("Invalid tabs JSON in reportProfile:", err);
      }
    }
  }, [reportProfile]);

  useEffect(() => {
    let didCancel = false;

    const resolveHomeUrl = async () => {
      if (reportProfile?.reportNavigationMode === 'assigned') { setHomeUrl('/mr'); localStorage.setItem('_home', '/mr'); return; }
      if (!appVars?.api_url || !reportProfile?.settings) return;

      let settings;
      try {
        settings = JSON.parse(reportProfile.settings);
      } catch (err) {
        console.error('Invalid settings JSON in reportProfile:', err);
        return;
      }

      const defaultReportId = settings?.default_report;
      if (!defaultReportId) return;

      try {
        const res = await fetch(`${appVars.api_url}/reports/list`);
        const data = await res.json();
        const list = Array.isArray(data) ? data : [];
        const found = list.find((item) => item?.pkRecID === defaultReportId);
        const nextHome = found?.settings?.location || '/mr';

        if (!didCancel) {
          setHomeUrl(nextHome);
          localStorage.setItem('_home', nextHome);
        }
      } catch (err) {
        console.error('Failed to resolve default report home URL:', err);
      }
    };

    resolveHomeUrl();

    return () => {
      didCancel = true;
    };
  }, [appVars?.api_url, reportProfile?.settings, reportProfile?.reportNavigationMode]);

  useEffect(() => {
    let didCancel = false;

    const rehydrateClientSession = async () => {
      if (!appVars?.api_url) return;

      const rid = hydrateReportId();
      if (!rid) return;

      const hasClientPayload =
        sessionStorage.getItem('client')
        && sessionStorage.getItem('apiID')
        && sessionStorage.getItem('aPort')
        && sessionStorage.getItem('agencyName')
        && sessionStorage.getItem('clientName');

      if (hasClientPayload) {
        try {
          const existingClient = sessionStorage.getItem('client');
          if (existingClient && !didCancel) {
            setClient(JSON.parse(existingClient));
          }
        } catch (error) {
          console.error('Failed to parse persisted client session payload:', error);
        }
        return;
      }

      try {
        const tagManagerRes = await fetch(`${appVars.api_url}/tagmanager/${rid}`);
        if (!tagManagerRes.ok) {
          throw new Error(`tagmanager/${rid} ${tagManagerRes.status}`);
        }

        const tagManagerData = await tagManagerRes.json();
        sessionStorage.setItem('client', JSON.stringify(tagManagerData));
        sessionStorage.setItem('apiID', tagManagerData.client ?? '');
        sessionStorage.setItem('aPort', tagManagerData.aPort ?? '');
        sessionStorage.setItem('agencyName', tagManagerData.clientname ?? '');
        sessionStorage.setItem('clientName', tagManagerData.name ?? '');

        if (!didCancel) {
          setClient(tagManagerData || {});
        }
      } catch (error) {
        console.error('Failed to rehydrate client session metadata:', error);
      }
    };

    rehydrateClientSession();

    return () => {
      didCancel = true;
    };
  }, [appVars?.api_url]);









  if (process.env.NODE_ENV !== 'production' && location.pathname.startsWith('/__visual/infillion')) {
    return <InfillionVisualHarness />;
  }


  if (profileLoading || appLoading || !menu) {
    return (
      <Box height="100vh" display="flex" alignItems="center" justifyContent="center" gap={2} flexDirection={'column'} >
        <Typography>Loading Application Variables</Typography>
        <CircularProgress size={25} />
      </Box>
    );
  }

  const BRANDING = {
    title: '',
    homeUrl,
    logo: (
      <Box sx={{ display: 'flex', gap: 5, alignItems: 'center', justifyContent: 'space-between' }}>
        {reportProfile.clientlogo === 1 && (
          <Box sx={{ display: { xs: 'none', sm: 'block' }, flex: 1 }}>
            <img src={reportProfile?.clientlogopath} alt="Logo" />
          </Box>
        )}
        <img src={`${appVars.api_url}/imageFiles/${client.id}.png`} alt="Logo" />
      </Box>
    )
  };






  return (
    <ThemeProvider theme={theme}>
      <TokenProvider>
        <UserProvider client={client} appVars={appVars} >
          <AppProvider
            session={{
              user: {
                name: user?.name || '',
                email: user?.email || '',
                image: `${appVars.api_url}/imageFiles/${client.owner}.png`,
              },
            }}
            branding={BRANDING}
            navigation={menu}
            theme={theme}
          router={sidebarRouter}
          >
            {reportProfile?.activeReport ? (
              <DashboardLayout
                sidebarExpandedWidth={224}
                sx={shellSx}
                slots={{
                  toolbarActions: () => (
                    <MonthlyToolbar
                      reportProfile={reportProfile}
                      reportRef={reportRef}
                      reportTitle={activeTitle}
                      currentPath={`${location.pathname}${location.search}${location.hash}`}
                      setSelectedDateS={setSelectedDateS}
                      setSelectedDateE={setSelectedDateE}
                      selectedDateS={selectedDateS}
                      selectedDateE={selectedDateE}
                      handleRangeSelect={handleRangeSelect}
                      client={client}
                      loading={loading}
                    />
                  ),
                  toolbarAccount: ToolbarAccountOverride,
                  sidebarFooter: SidebarFooterAccount,
                }}
              >
                <Box ref={reportRef} data-report-root="true" sx={{
                  ...getReportTableSx(theme),
                  '& .MuiLinearProgress-bar': {
                    backgroundImage: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                  },
                  width: '100%', minHeight: 'calc(100vh - 64px)', padding: 0, boxSizing: 'border-box',
                }}>
                  {element}
                </Box>
              </DashboardLayout>
            ) : (
              <ContactRep client={client} />
            )}
          </AppProvider>
        </UserProvider>
      </TokenProvider>
    </ThemeProvider>
  );
};

// Public link resolution must not load a previous client's profile or representative.
const ReportEntry = ({ appVars, appID }) => {
  const { pathname } = useLocation();
  const [accessRequired, setAccessRequired] = useState(null);
  useEffect(() => {
    const requireAccess = event => setAccessRequired(event.detail);
    window.addEventListener('report-access-required', requireAccess);
    return () => window.removeEventListener('report-access-required', requireAccess);
  }, []);
  useEffect(() => { setAccessRequired(null); }, [pathname]);
  const clearAccessRequired = useCallback(() => setAccessRequired(null), []);
  if (accessRequired?.slug) return <GoLinkSetter requestedSlug={accessRequired.slug} onAccessGranted={clearAccessRequired} />;
  if (pathname === '/go' || pathname.startsWith('/go/')) return <GoLinkSetter />;
  if (pathname.startsWith('/session/')) return <SetSessionInfo />;
  return <ReportProfileProvider appVars={appVars}>
    <UserProvider><AppWithVars appID={appID} /></UserProvider>
  </ReportProfileProvider>;
};

const AppWithVarsWrapped = () => {
  const { appVars, appID } = useContext(AppVarsContext);
  return (
    <BrowserRouter>
      <ReportEntry appVars={appVars} appID={appID} />
    </BrowserRouter>
  );
};

export default AppWithVarsWrapped;
